import reducer from './reducers';

import settingsOperations from './operations';
import { types as settingTypes } from './actions';

export { settingsOperations, settingTypes };

export default reducer;
